import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Navbar() {
  const { t, lang, toggleLang, isAr } = useLanguage();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [solid, setSolid] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 24);

      const solidMarker = document.querySelector('[data-header-solid]');
      if (solidMarker) {
        const top = solidMarker.getBoundingClientRect().top;
        setSolid(top <= 88);
      } else {
        setSolid(y > 24);
      }
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [location.pathname]);

  const links = [
    { to: '/', label: t.nav.home },
    { to: '/features', label: t.nav.features },
    { to: '/plus', label: t.nav.plus },
    { to: '/pricing', label: t.nav.pricing },
    { to: '/about', label: t.nav.about },
    { to: '/demo', label: t.nav.demo },
  ];

  const headerClass = [
    'site-header',
    scrolled ? 'is-scrolled' : 'is-top',
    isHome && !scrolled ? 'over-hero' : '',
    solid ? 'is-solid' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <header className={headerClass}>
      <div className="container header-inner">
        <Link to="/" className="brand">
          <img src="/haseela_h_logo.png" alt="Haseela" className="brand-logo" />
          <span className="brand-text">
            <strong>{isAr ? t.brand : 'Haseela'}</strong>
            <small>{isAr ? 'Haseela' : 'حصيلة'}</small>
          </span>
        </Link>

        <nav className={`nav-links ${open ? 'open' : ''}`}>
          {links.map((link) => (
            <NavLink key={link.to} to={link.to} end={link.to === '/'}>
              {link.label}
            </NavLink>
          ))}
          <Link to="/demo" className="btn btn-primary nav-cta">
            <span className="nav-cta-label">{t.nav.start}</span>
          </Link>
        </nav>

        <div className="header-actions">
          <button type="button" className="lang-toggle" onClick={toggleLang} aria-label="Toggle language">
            {lang === 'ar' ? 'EN' : 'عربي'}
          </button>
          <button
            type="button"
            className="menu-toggle"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? 'Close menu' : 'Open menu'}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
    </header>
  );
}
